import React from 'react';
import { DQ_METRIC_KIND, deltaPpColorClass, formatDeltaPp } from '../constants/dataQuality';

export default function DataQualityDeltaBadge({ value, metricKind = DQ_METRIC_KIND.VALID }) {
  const formatted = formatDeltaPp(value);
  if (formatted == null) {
    return <span className="text-xs text-gray-500">n/a</span>;
  }
  const cls = deltaPpColorClass(value, metricKind);
  return <span className={`text-xs font-semibold ${cls}`}>{formatted}</span>;
}
